import type { UserDetail } from 'models';
import { Card, Col, Icon, Row, Space, Tag, Text } from 'ui';
import { useGetUserAgeRange, useGetUserLocation } from '../../hooks';
import { MemberAboutEmptyState } from './member-about-empty-state';

type P = {
  member: UserDetail;
};

// eslint-disable-next-line sonarjs/cognitive-complexity -- TODO: fix
const MemberAboutCard = ({ member }: P) => {
  const { ageGroup, city, company, country, educationLevel, gender, interests, profession, state } = member;
  const getLocation = useGetUserLocation();
  const getAgeGroup = useGetUserAgeRange();
  const location = getLocation({ city, country, state });

  const hasGender = gender;
  const hasProfession = profession;
  const hasAgeGroup = ageGroup;
  const hasLocation = location;
  const hasEducationLevel = educationLevel;
  const hasCompany = company;
  const hasInterests = interests && interests.length > 0;

  const hasAnyInfo = [
    hasGender,
    hasProfession,
    hasAgeGroup,
    hasLocation,
    hasEducationLevel,
    hasCompany,
    hasInterests,
  ].some(Boolean);

  return (
    <Card title={<Card.Title icon={<Icon icon="information-line" />}>About</Card.Title>}>
      {hasAnyInfo ? (
        <Row gutter={['xs', 'xs']}>
          {hasGender ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Gender
                </Text>
              </Col>
              <Col span={18}>
                <Text>{gender.name}</Text>
              </Col>
            </>
          ) : null}

          {hasProfession ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Profession
                </Text>
              </Col>
              <Col span={18}>
                <Text>{profession.name}</Text>
              </Col>
            </>
          ) : null}

          {hasAgeGroup ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Age
                </Text>
              </Col>
              <Col span={18}>
                <Text>{getAgeGroup({ ageGroup })}</Text>
              </Col>
            </>
          ) : null}

          {hasLocation ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Location
                </Text>
              </Col>
              <Col span={18}>
                <Text>{location}</Text>
              </Col>
            </>
          ) : null}

          {hasEducationLevel ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Education level
                </Text>
              </Col>
              <Col span={18}>
                <Text>{educationLevel.name}</Text>
              </Col>
            </>
          ) : null}

          {hasCompany ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Company / School
                </Text>
              </Col>
              <Col span={18}>
                <Text>{company}</Text>
              </Col>
            </>
          ) : null}

          {hasInterests ? (
            <>
              <Col span={6}>
                <Text size="small" type="secondary">
                  Interests
                </Text>
              </Col>
              <Col span={18}>
                <Space size="small" wrap>
                  {interests.map((interest) => (
                    <Tag key={interest.id}>{interest.name}</Tag>
                  ))}
                </Space>
              </Col>
            </>
          ) : null}
        </Row>
      ) : (
        <MemberAboutEmptyState />
      )}
    </Card>
  );
};

export default MemberAboutCard;
